import Autocomplete from '@material-ui/lab/Autocomplete'
import { IconButton, TextField, Tooltip } from '@material-ui/core'
import { ParametreFonction } from '../../../store/constants/fonction/fonction'
import Icon from '@material-ui/core/Icon'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Box from '@material-ui/core/Box'

export const AddParam = ({ addParamHandler, existingParam }) => {
  const parametres = useSelector(state => state.parametreModule.parametres)
  const [selectedParam, setSelectedParam] = useState(null)
  const [listParam, setListParam] = useState([])

  const autocompleteChanged = (event, newValue) => {
    setSelectedParam(newValue)
  }
  const addParam = () => {
    addParamHandler(new ParametreFonction(selectedParam))
    setSelectedParam(null)
  }
  useEffect(() => {
    const list = existingParam.map(param => param.parametre.nom)
    setListParam(parametres.filter(param => !list.includes(param.nom)))
  }, [existingParam, setListParam])

  return (
    <>
      <Autocomplete
        id="size-small-outlined"
        size="small"
        options={listParam}
        value={selectedParam}
        getOptionLabel={option => option.nom}
        onChange={autocompleteChanged}
        renderInput={params => <TextField {...params} />}
      />
      <Tooltip title="Ajouter un paramètre">
        <Box>
          <IconButton disabled={!selectedParam} onClick={addParam}>
            <Icon color={selectedParam ? 'primary' : 'disabled'}>add_circle</Icon>
          </IconButton>
        </Box>
      </Tooltip>
    </>
  )
}
